import React from "react";
  import axios from 'axios';
  import axios2 from 'services/axios2';

  import {useParams} from "react-router-dom";
  import {Link,hashHistory} from 'react-router-dom';
  import { useNavigate } from "react-router-dom";

  import { ToastContainer, toast } from 'react-toastify';
  import { NuDropdown } from "components/nubox/NuDropdown";
  import  NuEstado from "components/nubox/NuEstado";

  import { withRouterJim } from "router/withRouterJim";

  //---cutil
  import cUtilFecha from "helpers/cUtilFecha"
  
  import NuConfirm from "components/nubox/Box/NuConfirm";
  import NuLoading from 'components/nubox/NuLoading';

  import { NotificationContainer, NotificationManager } from 'react-notifications';
  import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
    ToastHeader,
  } from "reactstrap";




  const data = [
    { id_paciente: 1,  nombre: 'ALEX LIZARRAGA', }, 
  ];

  //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
  class ExamendList extends React.Component {
    state = {

      modalActualizar: false,
      modalInsertar: false,
      isloaging:false,/* cargando ... */
      form: {
        name: '',
      },
      data: data,/* lista de datos */
      estados: [
        { value: 0, label: "Pendiente", clase:'badge bg-secondary' },
        { value: 1, label: "En curso", clase:'badge bg-success' },
        { value: 2, label: "Finalizado", clase:'badge bg-primary' },
        { value: 3, label: "Anulado", clase:'badge bg-danger' },
      ],
      
    };
     //--------------------------------------
    constructor(props) {
      super(props);

      this.modalRef = React.createRef();//create ref
      this.refNuConfirm = React.createRef();
    }
    //------------------
    
    //------------------------------------------------------
    componentDidMount() {
      //--limpiamos el array de prueba
      this.setState({data:[]});

      this.cargar_data();
      
      //this.cargar_cbo();
    }

    //----------------especial, actualiza valores del form -------------------------------
    handleChangeForm = (e) => {
      //requerimos la prop name='?' en cada control
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    };
    
    //====================================================== 
    //----cargamos los datos desde la base de datos
    cargar_data = () => {
      let user = this.props.store.user
      const materia = this.props.store.materia;

      let param = { 
        id_mate: materia.id_mate,
        id_peri: user.id_peri,
      }
      this.setState({isLoading: true});
      axios2.post("examend_get_list", param)
      .then(res => {
          this.setState({isLoading: false});

          if(res.data.length>0){ 
              this.setState({data: res.data});
          }else{
              NotificationManager.error("No existen datos");
          }

      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
          
      });
    };
    //--------------------------------------
    imprimir =(id_certi)=>{
      let fileURL = process.env.REACT_APP_API_URL  + "certificado_reciboPDF/"+ id_certi;
      let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
      window.open(fileURL,'',windowFeatures);
    }

    //-----------------------------------------------------------------
  nuevo = () => {
    this.modalRef.current.nuevo();
  }
  //-----------------------------------------------------------------
  
  //-----------------------------------------------------------------
  eliminar = (item) =>{
    console.log('eliminar.');
    
    
    this.refNuConfirm.current.show({
      message: 'Esta seguro de eliminar?',
      title: 'Confirmar',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
        
        let idd = item.id_exa;
        this.save(idd,'x');
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })

  }
  //-------------------------------------
  //-------------------------------------
  okModal =()=>{
    console.log('citaOkModal');
    this.cargar_data();
  }
  //-------------------------------------
  closeModal =()=>{
    console.log('citaCancelModal');
  }
  //-------------------------------------
  //--------------------------------------
  
  /* === This is where the magic happens ==== */
  handleSubmit = event => {
    event.preventDefault();
    this.cargar_data();
  }
  //-------------
  onLinkClick = (e,item) => {
    e.preventDefault();
    this.props.navigate('/docente/e/'+ item.id_doc);
  };
  //-------------
  //=================== SAVE
  save =(idd, ope) =>{
      
  //let param = { idd:idd, ope:ope };
  let param = this.state.form
  param.idd = idd
  param.ope = ope
  console.log(param);

  axios2.post("examend_store", param)
  .then(res => {
      console.log(res.data);
      if(res.data.exito === 1){ 
          toast.success(res.data.men);
          this.cargar_data();            
      }else{
          toast.error(res.data.men);
      }
  }).catch(error => {
      alert("---- Existio un error ---");
      console.log(error);
  });
}
//-------------------------------------
    
    //-------------------------------------
    render() {
      
      return (
        <div>
          <ToastContainer />
          <NotificationContainer/>
          <div className="content">

            {/*<!--- ------------------------------->*/}
            <div className="row">
              <div className="col-md-12">
                <h3> Lista de Examenes

                  <div className="btn-group pull-right">

                    <Link to={`/examend/0/n`}
                      className='create-modal btn btn-info ' >
                      <i className='fa fa-plus'></i> Nuevo 
                    </Link>
                  </div>
                </h3>
              </div>
            </div>

            <div className="row d-flex justify-content-center">
                <div className="box box-info">
                  {/*<!-- /.box-header -->*/}
                  <div className="box-body pad">

                    <form onSubmit = { this.handleSubmit }>
                      
                      <div className="row">

                        <div className="col-md-4">
                          <div className="form-group">
                            <label className="control-label">Busqueda:</label>
                            <input type="text" 
                                name = "name" 
                                onChange= {this.handleChangeForm} 
                                className="form-control input-sm" />
                          </div>
                        </div>

                        <div className="col-md-2">
                          <button type="submit" 
                              style={{ marginTop: "24px" }} 
                              className="btn btn-success ">
                              <i className="fa fa-binoculars"></i> Buscar</button>

                        </div>

                      </div>
                    </form>

                  </div>
                  {/*<!-- /.box-body -->*/}
                </div>
            </div>
            <NuLoading text="Cargando...." show= { this.state.isloaging }/>
            <div className="row">
                {/*<!-- box table -->*/}
                <div className="box">
                  <div className="box-header">
                    <br/>
                      <div className="col-md-12">


                        <div className="table-responsive">
                          <table className="table tabla_azul0 table-striped table-hover ">
                            <thead>
                              <tr>

                                <th>Cod. examen.</th>
                                <th>titulo</th>
                                <th>File</th>
                                <th>Fecha Ini.</th>
                                <th>Fecha Fin.</th>
                                <th>Estado</th>
                                <th className="text-center" style={{ width:"150px" }}>
                                  Acciones
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                          
                              {this.state.data.map((item,index) => (
                                <tr key={index}>
                                  <td>{ item.id_exa}</td>
                                  <td>{ item.titulo}</td>
                                  <td>{ item.filename}</td>
                                  <td>{ item.fecha_ini }</td>
                                  <td>{ item.fecha_fin }</td>
                                  <td>
                                    <NuEstado
                                       options={this.state.estados}
                                       name="id_estadoex"
                                       value={ item.id_estadoex }
                                    />
                                  </td>

                                  
                                  <td>
                                    <div className=''>
                                      
                                      <Link to= { "/examend/" + item.id_exa +"/e"  } 
                                        title="Editar" className="btn btn-warning btn-sm">
                                        <i className="fa fa-edit"></i>
                                      </Link>
                                      &nbsp;
                                      <Button className="btn btn-danger btn-sm" 
                                        title="Eliminar" 
                                        onClick={ ()=> this.eliminar(item) }  >
                                        <i className="fa fa-trash"></i> 
                                      </Button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                              

                            </tbody>
                            
                            </table>
                          
                        </div>

                      </div>


                  </div>
                </div>
                {/*<!-- fin box table -->*/}

            </div>

            
            {/*<!--- ----------------- form busqueda ------------------>*/}

            {/*<!-- -------------------------------------------------->*/}

          </div>
         
          <NuConfirm   ref={ this.refNuConfirm }    />
        </div>
      );
    }
  }
    
  //------------para que soporte la funcionalidad de parametros
  export default withRouterJim(ExamendList);

